import React from "react";
import { useTranslation } from "react-i18next";
import { RestaurantAddRequestStatus, RestaurantDeleteRequestStatus } from "@me-team/host/meBooking/graphql/types";
import { TaggedRequestItem } from "./types";
import { ADD_STATUS_BADGE, DELETE_STATUS_BADGE } from "./constants";

const StatusBadge: React.FC<{ item: TaggedRequestItem }> = ({ item }) => {
    const { t } = useTranslation();
    const badge =
        item.requestType === "add"
            ? ADD_STATUS_BADGE[item.status as RestaurantAddRequestStatus]
            : DELETE_STATUS_BADGE[item.status as RestaurantDeleteRequestStatus];
    if (!badge) return <span>{item.status}</span>;
    return <span className={`fs-7 d-inline-block px-2 py-1 rounded text-nowrap ${badge.cls}`}>{t(badge.label)}</span>;
};

export default StatusBadge;
